"use strict";
import { __exports as n } from "./index.es296.js";
var u;
function i() {
  return u ? n : (u = 1, (function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "errorOnce", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    let t = (r) => {
    };
    if (process.env.NODE_ENV !== "production") {
      const r = /* @__PURE__ */ new Set();
      t = (e) => {
        r.has(e) || console.error(e), r.add(e);
      };
    }
  })(n), n);
}
export {
  i as __require
};
//# sourceMappingURL=index.es260.js.map
